module.exports = __webpack_public_path__ + "static/YangAnimsForMountain_RUN-85bfe58946c40318259850481efd77b4.gif";